import React from "react"
import { useSelector } from "react-redux"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import PrinterCategoriesCard from "./PrinterCategoriesCard"
import { Checkbox, IconButton, SidebarModal, Spinner } from "components"
import classes from "./PrinterCategories.module.scss"

const PrinterCategories = props => {
  const {
    openSidebar,
    setOpenSidebar,
    printerCategoryIds,
    setPrinterCategoryIds
  } = props

  const [t, i18n] = useTranslation()

  const categories =
    useSelector(state => state.categories)

  const handleSelectAll = () => {
    const newPrinterCategoryNames = {}

    if (!isAllCategoriesSelected) {
      categories.forEach(category => {
        newPrinterCategoryNames[category._id] = true
      })
    }

    setPrinterCategoryIds(
      newPrinterCategoryNames
    )
  }

  const isAllCategoriesSelected =
    categories.length ===
    Object.keys(printerCategoryIds).length

  const loading =
    categories === null

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <SidebarModal
      urlQuery="categories"
      urlQueryValue="true"
      open={openSidebar}
      title={t("دسته_بندی_ها")}
      onClose={() => setOpenSidebar(false)}
    >
      <div className={classes["container"]}>
        {!loading
          ?
          <div className={classes["wrapper"]}>
            <div className={classes["category"]}>
              <div className={classes["row"]}>
                <div
                  className={clsx(
                    classes["category-text"],
                    isLtr && classes["category-text-ltr"]
                  )}
                >
                  {t("انتخاب_همه_ی_دسته_بندی_ها")}
                </div>
                <Checkbox
                  checked={isAllCategoriesSelected}
                  onChange={handleSelectAll}
                />
              </div>
            </div>

            {categories.map(category =>
              <PrinterCategoriesCard
                key={category._id}
                category={category}
                isSelected={!!printerCategoryIds[category._id]}
                setPrinterCategoryIds={setPrinterCategoryIds}
              />
            )}
          </div>
          :
          <div className={classes["wrapper"]}>
            <div className={classes["topbar"]}>
              <IconButton
                icon={MdClose}
                size={20}
                onClick={() => setOpenSidebar(false)}
              />
            </div>
            <div className={classes["loading"]}>
              <Spinner
                color="var(--color-primary)"
                size={30}
              />
            </div>
          </div>
        }
      </div>
    </SidebarModal>
  )
}

export default PrinterCategories